import * as api from './api';
import * as types from './mutations';
import { MessageBox } from 'element-ui';

const paymentFailure = message => {
    MessageBox.alert(message, 'Payment Process Failure', {type: 'error'});
};

const state = {
    isProcessing: false,
    invoices: {
        data: [],
        pagination: {},
        latest: {}
    },
    recentViewedCourse: undefined,
    cancellationRequest: undefined
};

const getters = {

};

const actions = {
    fetch({}, query = 'include=profession,employmentStatus,learningFormat') {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/member/profile?${query}`)
                .then(({ data }) => {
                    resolve(data.data)
                })
        });
    },

    updateMemberProfile({commit}, formData) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.patch(api.updateMemberProfile, formData)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    cancelMembership({commit}, payload) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.post(api.scheduleCancelMembership, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getRecentViewedCourse({commit, state}) {
        return new Promise((resolve, reject) => {
            if (state.recentViewedCourse) {
                return resolve(state.recentViewedCourse);
            }

            axios.get(api.getRecentViewedCourse)
                .then(({data}) => {
                    if (data.course) {
                        commit(types.UPDATE_RECENT_VIEWED_COURSE, data.course.data);
                        resolve(data.course.data);
                    }
                })
                .catch(({response}) => reject(response));
        });
    },

    saveRecentViewedCourse({commit}, {course}) {
        return new Promise((resolve) => {
            axios.patch(api.saveRecentViewedCourse, {hashedId: course.id})
                .then(({data}) => {
                    commit(types.UPDATE_RECENT_VIEWED_COURSE, course);
                    resolve(data);
                });
        });
    },

    getInvoices({commit}, {page = 1}) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);
            axios.get(api.getInvoices(page))
                .then(({data}) => {
                    commit(types.UPDATE_INVOICES, {data: data.invoices.data, pagination: data.invoices.meta.pagination});
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getLatestInvoice({commit, state}) {
        /**
         * If we've already fetched invoices from My Invoices component,
         * then we can assume the first invoice is latest one.
         * Early return so we do not have to make a request.
         */
        if (state.invoices.data.length) {
            commit(types.SET_LATEST_INVOICE, state.invoices.data[0]);

            return;
        }

        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);
            axios.get(api.getLatestInvoice)
                .then(({data}) => {
                    commit(types.SET_LATEST_INVOICE, data.invoice.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    updateCreditCard({commit}, token) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.post(api.updateCreditCard, {token})
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response.data.message))
                .done(_ => commit(types.SET_PROCESSING_STATE, false))
        })
    },

    changeMembership({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.post(api.changeMembership, payload)
                .then(({data}) => resolve(data.data))
                .catch(({response}) => {
                    if (response.data.code === 402) {
                        paymentFailure(response.data.message);
                        reject(undefined);
                    } else {
                        reject(response);
                    }
                })
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getCancellationRequest({commit, state}) {
        if (state.cancellationRequest) return;

        return new Promise((resolve, reject) => {
            axios.get(api.cancellationRequest)
                .then(({data}) => {
                    commit(types.SET_CANCELLATION_REQUEST, data.cancellation.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response));
        });
    },

    getPaymentGatewayToken({commit}, member) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/v2/members/${member.id}/paymentGateway/token`)
                .then(({data}) => {
                    resolve(data.token);
                })
                .catch(({response}) => reject(response));
        });
    },

    createPaymentGateway({commit}, { member, paymentToken }) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/v2/members/${member.id}/paymentGateway`, {
                paymentToken
            })
                .then(({data}) => {
                    resolve(data.token);
                })
                .catch(({response}) => reject(response));
        });
    }
};

const mutations = {
    [types.UPDATE_INVOICES](state, {data, pagination}) {
        state.invoices.data = data;
        state.invoices.pagination = pagination;
    },

    [types.UPDATE_RECENT_VIEWED_COURSE](state, course) {
        state.recentViewedCourse = course;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_LATEST_INVOICE](state, invoice) {
        state.invoices.latest = invoice;
    },

    [types.SET_CANCELLATION_REQUEST](state, cancellation) {
        state.cancellationRequest = cancellation;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};
